import DateInput from '@/components/atoms/DateInput';
import { TRosterUserPeerSupportCertificateInfo } from '@/types/Roster.types';
import { Input, Text } from '@chakra-ui/react';
import { addDays, isBefore } from 'date-fns';
import React, { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

interface Props {
  methods: UseFormReturn<TRosterUserPeerSupportCertificateInfo, any, undefined>;
}

const PeerSupportCertificationForm = ({ methods }: Props) => {
  const { register, watch, setValue, formState } = methods;
  const { errors, touchedFields } = formState;

  const dateOfIssue = watch('dateOfIssue');
  const validUntil = watch('validUntil');

  const dateOfIssueAfterOneDay = dateOfIssue ? addDays(new Date(dateOfIssue), 1) : undefined;

  useEffect(() => {
    if (validUntil && dateOfIssueAfterOneDay) {
      const validUntilDate = new Date(validUntil);
      if (isBefore(validUntilDate, dateOfIssueAfterOneDay)) {
        setValue('validUntil', dateOfIssueAfterOneDay.toISOString().split('T')[0]);
      }
    }
  }, [validUntil, dateOfIssueAfterOneDay]);

  return (
    <>
      <DateInput
        title="Date of Issue"
        value={dateOfIssue}
        registerFormField={register}
        registerFormFieldName="dateOfIssue"
        errorMessage={errors.dateOfIssue?.message}
      />

      <DateInput
        title="Valid Until"
        value={validUntil}
        minValue={dateOfIssueAfterOneDay?.toISOString().split('T')[0]}
        registerFormField={register}
        registerFormFieldName="validUntil"
        errorMessage={errors.validUntil?.message}
      />

      <Input
        {...register('certificateId', { required: true })}
        className="custom-input"
        placeholder={'Certificate ID'}
        type="text"
        _placeholder={{
          fontWeight: '600',
          color: 'background.blueGray',
          fontSize: '14px',
        }}
        data-state={touchedFields.certificateId ? (errors.certificateId?.message ? 'invalid' : 'valid') : ''}
      />

      {errors.certificateId && <Text variant={'error'}>{errors.certificateId.message}</Text>}
    </>
  );
};

export default PeerSupportCertificationForm;
